module.exports = __webpack_public_path__ + "02_glasses_blue.31c42148.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/02_glasses_blue.png
// module id = UNb6
// module chunks = 0